<div class="store_front_analytics_page invoces_page">
    <div class="dashboard_header d-flex justify-content-between">
        <h2 i18n="@@storefront_analytics.header">Storefront analytics</h2>
        <div class="custom_select">
            <div class="custom_select-header" (click)="toggleCalendar($event)">
                <div>{{ selectedText }}</div>
                <div class="custom_select-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="#0A0A0A"
                            stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <ul class="custom_select-content pl-0" style="display: none;">

                <li *ngFor="let option of dateOptions"
                    class="custom_select-item d-flex align-items-center justify-content-between"
                    (click)="selectItem($event, option)">
                    <span>{{ option.label }}</span>
                    <span>{{ option.range }}</span>
                </li>
                <li
                    class="custom_select-item d-flex align-items-center justify-content-between"
                    (click)="selectItem($event, null); openDataPicker()">
                    <span i18n="@@dashboard.custom_range">Custom range</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20"
                            height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#393939"
                                stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                </li>
            </ul>
            <div id="custom_datepicker-popup"
                class="custom_datepicker-popup hidden">
                <div class="d-flex align-items-center gap-2 mb-3">
                    <span i18n="@@dashboard.from">from</span> <input #startDayInput id="start_day_input" type="text"
                        placeholder="Start date" readonly>
                        <span i18n="@@dashboard.to">to</span><input #endDayInput id="end_day_input" type="text"
                        placeholder="End date" readonly>
                </div>
                <div class="custom_datepicker-header">
                    <span id="month-year">{{ monthNames[currentDate.getMonth()]
                        }} {{ currentDate.getFullYear() }}</span>
                    <div class="d-flex align-items-center gap-2">
                        <div
                            (click)="currentDate.setMonth(currentDate.getMonth() - 1); updateCalendar();">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26"
                                height="26" viewBox="0 0 26 26" fill="none">
                                <path
                                    d="M21.6988 15.6736L13.5725 7.54729C13.4184 7.39469 13.2103 7.30908 12.9935 7.30908C12.7766 7.30908 12.5685 7.39469 12.4145 7.54729L4.28814 15.6736C4.1779 15.7911 4.10318 15.9374 4.07262 16.0956C4.04206 16.2538 4.05691 16.4174 4.11546 16.5675C4.17763 16.7154 4.28218 16.8416 4.41595 16.9302C4.54972 17.0187 4.70671 17.0657 4.86714 17.0652H21.1198C21.2802 17.0657 21.4372 17.0187 21.571 16.9302C21.7048 16.8416 21.8093 16.7154 21.8715 16.5675C21.93 16.4174 21.9449 16.2538 21.9143 16.0956C21.8838 15.9374 21.809 15.7911 21.6988 15.6736Z"
                                    fill="#222222" />
                            </svg>
                        </div>
                        <div
                            (click)="currentDate.setMonth(currentDate.getMonth() + 1); updateCalendar();">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26"
                                height="26" viewBox="0 0 26 26" fill="none">
                                <path
                                    d="M21.8759 9.43671C21.8137 9.28881 21.7092 9.16262 21.5754 9.07404C21.4416 8.98547 21.2846 8.93847 21.1242 8.93897H4.87154C4.7111 8.93847 4.55411 8.98547 4.42034 9.07404C4.28658 9.16262 4.18202 9.28881 4.11985 9.43671C4.06131 9.58681 4.04645 9.75042 4.07701 9.90861C4.10757 10.0668 4.1823 10.2131 4.29254 10.3306L12.4189 18.4569C12.5742 18.6071 12.7818 18.6911 12.9979 18.6911C13.2139 18.6911 13.4215 18.6071 13.5769 18.4569L21.7032 10.3306C21.8134 10.2131 21.8882 10.0668 21.9187 9.90861C21.9493 9.75042 21.9344 9.58681 21.8759 9.43671Z"
                                    fill="#222222" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="custom_datepicker-days">
                    <span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span>
                </div>
                <div class="custom_datepicker-grid" #datepickerGrid></div>
                <div class="custom_datepicker-footer">
                    <button (click)="cancelDataPicker()"
                        class="secondary_btn w-100"
                        style="height: 40px;">Cancel</button>
                    <button (click)="applyDateRange()" class="primary_btn w-100"
                        style="height: 40px;">Apply</button>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex gap-4 flex-xl-nowrap">

        <div class="base_analytics_section green">
            <app-most-popular-products [purchasesData]="mostPopularProducts.by_purchase" [clicksData]="mostPopularProducts.by_click"></app-most-popular-products>
        </div>
        <div class="base_analytics_section red">
            <app-least-popular-products [purchasesData]="leastPopularProducts.by_purchase" [clicksData]="leastPopularProducts.by_click"></app-least-popular-products>
        </div>
    </div>
    <div class="d-flex gap-4 flex-xl-nowrap">
        <div class="base_analytics_section green">
            <div class="base_analytics_section-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
                    <rect width="54" height="54" rx="27" fill="#E6FFD7"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.5 29.4999L38.0024 35.2783C37.7551 35.8723 36.8688 36.8458 36.2827 37.1228C35.6705 37.4121 34.9761 37.4401 33.7401 37.4401L19.7394 37.4428V38.7376C19.7394 39.0772 19.8792 39.3857 20.1053 39.6093C20.3321 39.832 20.6448 39.9702 20.9891 39.9702H38.7917C39.1699 39.9702 39.4769 40.2729 39.4769 40.6463C39.4769 41.0197 39.1699 41.3221 38.7917 41.3221H36.0552C36.2789 41.6106 36.4118 41.9722 36.4118 42.3638C36.4118 43.3126 35.6325 44.0816 34.6705 44.0816C33.7086 44.0816 32.9289 43.3126 32.9289 42.3638C32.9289 41.9722 33.0618 41.6106 33.2855 41.3221H24.618C24.8417 41.6106 24.975 41.9722 24.975 42.3638C24.975 43.3126 24.1953 44.0816 23.2333 44.0816C22.2714 44.0816 21.4917 43.3126 21.4917 42.3638C21.4917 41.9722 21.6249 41.6106 21.8483 41.3221H20.9891C19.55 41.3221 18.3688 40.1571 18.3688 38.7376V36.8299L14.7286 20.7681H10.6036C10.2251 20.7681 9.91846 20.4653 9.91846 20.092C9.91846 19.7189 10.2251 19.4162 10.6036 19.4162L15.2746 19.4189C15.5881 19.4186 15.8707 19.6328 15.9409 19.947L16.6223 22.9535C18.0038 22.9535 26.8395 22.7527 27.504 22.9535C28.6459 23.2987 29.8148 26.4999 30.5 26.4999C31.4135 26.4999 34.3581 23.9999 35.5 23.9999C36.8703 23.9999 40.5 29.4999 40.5 29.4999Z" fill="#18F121"/>
                    <path d="M43.7095 26.185C43.681 26.3443 43.5936 26.4857 43.4634 26.5767L41.4786 27.9859C41.3754 28.059 41.2563 28.0948 41.1404 28.0948C40.9515 28.0948 40.7657 28.0038 40.6514 27.8331L36.1484 21.1935L31.2657 24.6636C31.1355 24.7563 30.9751 24.792 30.8211 24.7628C30.6655 24.7335 30.5273 24.6441 30.4384 24.5109L29.0618 22.4792L24.0998 15.1601L22.7295 16.1353C22.5406 16.2686 22.2944 16.28 22.096 16.1646C21.8975 16.0492 21.78 15.8265 21.7959 15.5925L22.1833 9.93445C22.196 9.75078 22.2897 9.58174 22.4373 9.47608C22.585 9.37043 22.7724 9.33955 22.9454 9.39319L28.2582 11.0007C28.4773 11.0673 28.6409 11.2559 28.6774 11.4883C28.7139 11.7191 28.617 11.9515 28.4297 12.0864L27.0594 13.0617L31.6831 19.8802L36.5674 16.41C36.6976 16.3174 36.858 16.2816 37.012 16.3109C37.1676 16.3402 37.3058 16.4295 37.3947 16.5628L38.7682 18.5913L43.611 25.7314C43.7031 25.8614 43.7381 26.0257 43.7095 26.185Z" fill="#18F121"/>
                </svg>
                <span i18n="@@storefront_analytics.most_added_products">Most added products</span>
            </div>
            <div class="base_analytics_section-body">
                <div class="d-flex flex-column w-100">

                    <div *ngFor="let item of mostPopularProducts.carts" class="analytics_card">
                        <img [src]="item.img" alt="item" (error)="onImgError(item)" class="item-image" loading="lazy"/>
                        <div class="d-flex flex-column w-100 gap-2">
                            <div class="d-flex align-items-center justify-content-between flex-wrap">
                                <span class="name">{{ item.name }}</span>
                                <!-- <span class="price">{{ item.price }}</span> -->
                                <div>
                                    <span [innerHtml]="item?.currency_symbol"></span>
                                    <span class="price"> {{item.amount}}</span>
                                </div>
                            </div>
                            <span class="counter">{{ item.sold }}</span>
                            <!-- <div class="d-flex align-items-center gap-2">
                                <div class="counter_persent">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M10.5407 8.41748L6.99982 11.9583L3.45898 8.41748" stroke="#FF0000" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7 2.04169V11.8592" stroke="#FF0000" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    -2,9%
                                </div>
                                <span class="period">since last month</span>
                            </div> -->
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="base_analytics_section red">
            <div class="base_analytics_section-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">
                    <rect width="54" height="54" rx="27" fill="#FFCCCC"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M36.7944 25.144L35.4578 33.1015C35.2336 33.64 34.4302 34.5224 33.8989 34.7736C33.3439 35.0358 32.7145 35.0612 31.5941 35.0612L18.9026 35.0636V36.2373C18.9026 36.5452 19.0293 36.8248 19.2342 37.0276C19.4398 37.2294 19.7233 37.3547 20.0354 37.3547H36.1733C36.5161 37.3547 36.7944 37.6291 36.7944 37.9676C36.7944 38.306 36.5161 38.5802 36.1733 38.5802H33.6927C33.8955 38.8417 34.016 39.1695 34.016 39.5245C34.016 40.3845 33.3095 41.0816 32.4375 41.0816C31.5655 41.0816 30.8587 40.3845 30.8587 39.5245C30.8587 39.1695 30.9792 38.8417 31.182 38.5802H23.325C23.5278 38.8417 23.6486 39.1695 23.6486 39.5245C23.6486 40.3845 22.9418 41.0816 22.0698 41.0816C21.1978 41.0816 20.491 40.3845 20.491 39.5245C20.491 39.1695 20.6118 38.8417 20.8143 38.5802H20.0354C18.7308 38.5802 17.6601 37.5241 17.6601 36.2373V34.508L14.3603 19.9482H10.6211C10.2779 19.9482 10 19.6737 10 19.3353C10 18.9972 10.2779 18.7227 10.6211 18.7227L14.8553 18.7252C15.1394 18.7249 15.3956 18.919 15.4593 19.2039L16.077 21.9293C17.3292 21.9293 25.3351 21.7472 25.9375 21.9293C26.9726 22.2422 28.0359 24.2376 28.6569 24.2376C29.485 24.2376 32.1542 22.4246 33.1894 22.4246C34.4315 22.4246 36.7944 25.144 36.7944 25.144Z" fill="#FF0000"/>
                    <path d="M43.6123 22.8928L43.2588 27.8231C43.2468 27.9833 43.1624 28.1303 43.0272 28.2223C42.9362 28.2853 42.8277 28.3168 42.7192 28.3168C42.6684 28.3168 42.6161 28.3102 42.5653 28.2945L37.733 26.8935C37.5335 26.8357 37.3848 26.6703 37.3514 26.4681C37.3179 26.2659 37.4063 26.0637 37.5776 25.9468L38.8242 25.0986L34.6198 19.1613L30.1772 22.1838C29.9309 22.3506 29.5948 22.2915 29.4234 22.0499L23.7678 14.0602C23.6861 13.9446 23.654 13.8015 23.6794 13.6637C23.7049 13.5258 23.7852 13.4024 23.903 13.3223L25.7079 12.0946C25.9542 11.9279 26.2903 11.987 26.4617 12.2286L30.556 18.015L34.9972 14.9938C35.2423 14.827 35.5797 14.8861 35.7511 15.1277L41.5164 23.2721L42.7629 22.4226C42.9343 22.3057 43.1579 22.2965 43.34 22.3976C43.5207 22.4948 43.627 22.6893 43.6123 22.8928Z" fill="#FF0000"/>
                </svg>
                <span i18n="@@storefront_analytics.least_added_products">Least added products</span>
            </div>
            <div class="base_analytics_section-body">
                <div class="d-flex flex-column w-100">
                    <div *ngFor="let item of leastPopularProducts.carts" class="analytics_card">
                        <img [src]="item.img" alt="item" (error)="onImgError(item)" class="item-image" loading="lazy"/>
                        <div class="d-flex flex-column w-100 gap-2">
                            <div class="d-flex align-items-center justify-content-between flex-wrap">
                                <span class="name">{{ item.name }}</span>
                                <!-- <span class="price">{{ item.price }}</span> -->
                                <div>
                                    <span [innerHtml]="item?.currency_symbol"></span>
                                    <span class="price"> {{item.amount}}</span>
                                </div>
                            </div>
                            <span class="counter">{{ item.sold }}</span>
                            <!-- <div class="d-flex align-items-center gap-2">
                                <div class="counter_persent">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M10.5407 8.41748L6.99982 11.9583L3.45898 8.41748" stroke="#FF0000" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7 2.04169V11.8592" stroke="#FF0000" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    -2,9%
                                </div>
                                <span class="period">since last month</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex gap-4 flex-xl-nowrap">
        <div class="base_analytics_section">
            <app-top-customers
                class="d-flex flex-column gap-3"
                [analyticsData]="topOrderingCustomers"
            ></app-top-customers>
        </div>

        <div class="base_analytics_section">
            <app-top-customer-locations [markers]="markers"></app-top-customer-locations>
            <app-top-district [topDistrict]="topDistrict" [currencySymbol]="currencySymbol" style="width: 100% !important;"></app-top-district>
        </div>
        <div class="base_analytics_section">
            <app-influencer-analytics [influencerData]="influencerData"></app-influencer-analytics>
        </div>
    </div>


    <div class="base_analytics_section">
        <app-promocode-analytics [promocode]="promocodeAnalytics" [currencySymbol]="currencySymbol" style="width: 100% !important;"></app-promocode-analytics>
        <app-abandoned-cart [abandonedCart]="abandonedCart" [currencySymbol]="currencySymbol" style="width: 100% !important;"></app-abandoned-cart>
    </div>
</div>

<!-- <div class="store_front_analytics_page">
    <h2>
        Storefront analytics
        <div class="custom_select">
            <div class="custom_select-header" (click)="toggleDropdown()">
                <div>{{ selectedOption }}</div>
                <div class="custom_select-icon"
                    [ngClass]="{'open': isDropdownOpen}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="#0A0A0A"
                            stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div class="custom_select-content" *ngIf="isDropdownOpen">
                <div
                    class="custom_select-item"
                    *ngFor="let option of options"
                    (click)="selectOption(option)">
                    {{ option }}
                </div>
            </div>
        </div>
    </h2>
    <div class="d-flex align-items-center gap-4">
        <app-most-popular-products></app-most-popular-products>
    </div>
    <div class="d-flex align-items-center gap-4">
        <app-most-popular-products></app-most-popular-products>
    </div>
</div> -->
